module.exports = __webpack_public_path__ + "img/background-01.682187f1.jpg";